import React from 'react';
import cn from 'classnames';
import Tabs from '../Tabs/Tabs';
import Tab from '../Tab/Tab';
import styles from './ViewTabs.module.scss';

const ViewTabs = ({ value, onChange, items, className, ...props }) => {
  return (
    <Tabs
      {...props}
      className={cn(styles.tabs, className)}
      value={value}
      onChange={onChange}
    >
      {items.map((item) => (
        <Tab
          selectedClassName={styles.tabActive}
          icon={item.renderIcon({ className: styles.icon })}
          className={styles.tab}
          key={item.key}
          value={item.key}
        />
      ))}
    </Tabs>
  );
};

export default ViewTabs;
